// @ts-check

import facebookLogo from "assets/logos/facebook-small.png";

import { getFacebookLoginUrl } from "./facebook";

export const getPlatformConnectionUrl = (platform, shopUrl, state = {}) => {
  if (platform.key === "facebook") {
    return getFacebookLoginUrl(shopUrl, state);
  }
};

export const PLATFORM_LOGOS = {
  facebook: facebookLogo,
};
